import React, {Component} from 'react';

export default class Ophtalmologiste extends Component {
  render() {
    return (
      <div>


      </div>
    );
  }
}
